import React from 'react';
import PropTypes from 'prop-types';

import { CustomTooltip } from 'src/components/CustomTooltip';
import { DetectedBrandTermTooltipContent } from '../DetectedBrandTermTooltipContent';
import { useStyles } from './useStyles';

export const InsightsLeaf = ({ attributes, leaf, children }) => {
  const styles = useStyles();

  return (
    <CustomTooltip
      classes={{ tooltip: styles.tooltip }}
      title={
        leaf.data?.brandTerm ? (
          <DetectedBrandTermTooltipContent detectedBrandTerm={leaf.data} />
        ) : (
          ''
        )
      }
      arrow={false}
      interactive
    >
      <span
        {...attributes}
        {...(leaf.decoration && { 'data-decoration': leaf.decoration })}
      >
        {children}
      </span>
    </CustomTooltip>
  );
};

InsightsLeaf.propTypes = {
  attributes: PropTypes.shape({}),
  leaf: PropTypes.shape({
    decoration: PropTypes.string,
    data: PropTypes.shape({
      brandTerm: PropTypes.shape(),
    }),
  }),
  children: PropTypes.shape({}),
};

InsightsLeaf.defaultProps = {
  attributes: null,
  leaf: null,
  children: null,
};
